export default __webpack_public_path__ + "static/media/avatar.d82b93d2.jpg";